/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CashbackDto,
  GetInvoiceBillingHistoryParams,
  InvoiceSummaryDto,
  OrganisationBillingDto,
  OrganisationLimitStatusDto,
  PageInvoiceBillingHistoryDto,
  PricingModelVersionDto,
  PricingPlanSummaryDto,
  StripeSessionDetails,
  UpdateBillingRequestDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiOrganisationBillingController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-organisation-billing-controller
   * @name GetBillingAccount
   * @request GET:/api/v1/organisation-billing
   */
  getBillingAccount = (params: RequestParams = {}) =>
    this.http.request<OrganisationBillingDto, any>({
      path: `/v1/organisation-billing`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getBillingAccountPath = '/v1/organisation-billing'
  static getBillingAccountMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-billing-controller
   * @name UpdateBilling
   * @request PUT:/api/v1/organisation-billing
   */
  updateBilling = (data: UpdateBillingRequestDto, params: RequestParams = {}) =>
    this.http.request<OrganisationBillingDto, any>({
      path: `/v1/organisation-billing`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateBillingPath = '/v1/organisation-billing'
  static updateBillingMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-organisation-billing-controller
   * @name PostUpgradeRequest
   * @request POST:/api/v1/organisation-billing/upgrade-requests
   */
  postUpgradeRequest = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/organisation-billing/upgrade-requests`,
      method: 'POST',
      ...params,
    })

  static postUpgradeRequestPath = '/v1/organisation-billing/upgrade-requests'
  static postUpgradeRequestMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-billing-controller
   * @name DownloadCashBackPdf
   * @request GET:/api/v1/organisation-billing/v2/cashbacks/{id}/pdf
   */
  downloadCashBackPdf = (id: number, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/organisation-billing/v2/cashbacks/${id}/pdf`,
      method: 'GET',
      ...params,
    })

  static downloadCashBackPdfPath = '/v1/organisation-billing/v2/cashbacks/${id}/pdf'
  static downloadCashBackPdfMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-billing-controller
   * @name CreateStripeCheckoutSession
   * @request GET:/api/v1/organisation-billing/stripe/customer/checkout-session
   */
  createStripeCheckoutSession = (params: RequestParams = {}) =>
    this.http.request<StripeSessionDetails, any>({
      path: `/v1/organisation-billing/stripe/customer/checkout-session`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static createStripeCheckoutSessionPath =
    '/v1/organisation-billing/stripe/customer/checkout-session'
  static createStripeCheckoutSessionMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-billing-controller
   * @name GetPricingPlanVersion
   * @request GET:/api/v1/organisation-billing/pricing-plan-version
   */
  getPricingPlanVersion = (params: RequestParams = {}) =>
    this.http.request<PricingModelVersionDto, any>({
      path: `/v1/organisation-billing/pricing-plan-version`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPricingPlanVersionPath = '/v1/organisation-billing/pricing-plan-version'
  static getPricingPlanVersionMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-billing-controller
   * @name GetPricingPlanSummary
   * @request GET:/api/v1/organisation-billing/pricing-plan-summary
   */
  getPricingPlanSummary = (params: RequestParams = {}) =>
    this.http.request<PricingPlanSummaryDto, any>({
      path: `/v1/organisation-billing/pricing-plan-summary`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPricingPlanSummaryPath = '/v1/organisation-billing/pricing-plan-summary'
  static getPricingPlanSummaryMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-billing-controller
   * @name GetCashbacks
   * @request GET:/api/v1/organisation-billing/organisations/cashbacks
   */
  getCashbacks = (params: RequestParams = {}) =>
    this.http.request<CashbackDto[], any>({
      path: `/v1/organisation-billing/organisations/cashbacks`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCashbacksPath = '/v1/organisation-billing/organisations/cashbacks'
  static getCashbacksMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-billing-controller
   * @name GetLimitStatus
   * @request GET:/api/v1/organisation-billing/limit-status
   */
  getLimitStatus = (params: RequestParams = {}) =>
    this.http.request<OrganisationLimitStatusDto, any>({
      path: `/v1/organisation-billing/limit-status`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getLimitStatusPath = '/v1/organisation-billing/limit-status'
  static getLimitStatusMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-billing-controller
   * @name DownloadPdf
   * @request GET:/api/v1/organisation-billing/invoices/{id}/pdf
   */
  downloadPdf = (id: number, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/organisation-billing/invoices/${id}/pdf`,
      method: 'GET',
      ...params,
    })

  static downloadPdfPath = '/v1/organisation-billing/invoices/${id}/pdf'
  static downloadPdfMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-billing-controller
   * @name GetInvoiceSummary
   * @request GET:/api/v1/organisation-billing/invoice-summary
   */
  getInvoiceSummary = (params: RequestParams = {}) =>
    this.http.request<InvoiceSummaryDto, any>({
      path: `/v1/organisation-billing/invoice-summary`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getInvoiceSummaryPath = '/v1/organisation-billing/invoice-summary'
  static getInvoiceSummaryMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-billing-controller
   * @name GetInvoiceBillingHistory
   * @request GET:/api/v1/organisation-billing/invoice-billing-history
   */
  getInvoiceBillingHistory = (query: GetInvoiceBillingHistoryParams, params: RequestParams = {}) =>
    this.http.request<PageInvoiceBillingHistoryDto, any>({
      path: `/v1/organisation-billing/invoice-billing-history`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getInvoiceBillingHistoryPath = '/v1/organisation-billing/invoice-billing-history'
  static getInvoiceBillingHistoryMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-billing-controller
   * @name GetCurrentPlan
   * @request GET:/api/v1/organisation-billing/current-plan
   * @deprecated
   */
  getCurrentPlan = (params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/organisation-billing/current-plan`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCurrentPlanPath = '/v1/organisation-billing/current-plan'
  static getCurrentPlanMethod = 'GET'
}
